export default "__VITE_ASSET__BgK9GOwO__"